import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { OperatorShell } from '@/app/shell/OperatorShell';
import { isAdmin, session } from '@/lib/auth/session';

export const Route = createFileRoute('/_authed/ops')({
  beforeLoad: () => {
    if (!isAdmin(session.get())) throw redirect({ to: '/' });
  },
  component: () => (
    <OperatorShell>
      <Outlet />
    </OperatorShell>
  ),
});
